import axios from "axios";
import { Base_URL } from "../url";

// Get all countries
export const getAllCountries = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CountryMaster/GetAllCountries`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching countries!";
  }
};

// Get regions by country
export const getRegionsByCountry = async (countryCode) => {
  try {
    const response = await axios.post(`${Base_URL}/RegionMaster/GetRegionsByCountry`, {
      countryCode: countryCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching regions!";
  }
};

// Get districts by region
export const getDistrictsByRegion = async (regionCode) => {
  try {
    const response = await axios.post(`${Base_URL}/DistrictMaster/GetDistrictsByRegion`, {
      regionCode: regionCode
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching districts!";
  }
};

// Create new tehsil
export const createTehsil = async (tehsilData, userName = "11") => {
  try {
    const response = await axios.post(
      `${Base_URL}/TehsilMaster/CreateTehsil?UserName=${userName}`,
      tehsilData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating tehsil!";
  }
};